import type { ActivityFormPayload } from "@/services/api/activity/types";
import type { ActivityInfo } from "@/services/api/activity/types";
import {
  formatDate,
  toImageList,
  toTwentyFourHourClock,
} from "./activityFormat";

export const emptyActivityForm = (): ActivityFormPayload => ({
  imageUrls: [],
  title: "",
  fee: "",
  maxParticipants: "",
  date: "",
  time: "",
  meetingDate: "",
  meetingTime: "",
  deadlineDate: "",
  deadlineTime: "",
  location: "",
  meetingLocation: "",
  description: "",
  category: "",
});

export const toActivityFormPayload = (
  activity: ActivityInfo,
): ActivityFormPayload => {
  return {
    imageUrls: toImageList(activity.cdn_activity_image),
    title: activity.title ?? "",
    fee: activity.fee ?? "",
    maxParticipants: activity.max_participants ?? "",
    date: formatDate(activity.date),
    time: toTwentyFourHourClock(activity.time),
    meetingDate: formatDate(activity.meeting_date),
    meetingTime: toTwentyFourHourClock(activity.meeting_time),
    deadlineDate: formatDate(activity.deadline_date),
    deadlineTime: toTwentyFourHourClock(activity.deadline_time),
    location: activity.location ?? "",
    meetingLocation: activity.meeting_location ?? "",
    description: activity.description ?? "",
    category: activity.category ?? "",
  };
};
